<template>
  <Layout />
</template>

<script>
import Layout from "./components/Layout/Layout.vue";

export default {
  name: "AgriPilotsSolutions",
  components: {
    Layout,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
